// extracted by mini-css-extract-plugin
module.exports = {"figure":"Figure4--figure--3CPNU","background":"Figure4--background--3Qa75"};